<template lang="pug">
div.box
    v-server-table(
        :url="api",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
</template>

<script>
export default {
    data: function() {
        var that = this;
        return {
            tableName: 'VUETABLE_VARIANT_SALES',
            columns: [
                'code',
                'product',
                'variant',
                'total_quantity',
                'total_net_sales',
            ],
            options: {
                skin: 'table m-b-0 b-b',
                texts: {
                    title: 'Product Sales by Variant',
                    description: 'Shows product sales by variant',
                },
                templates: {
                    total_net_sales: (h, row) => {
                        return numeral(
                            parseFloat(row.total_net_sales),
                        ).format();
                    },
                },
                useReportFilter: true,
                headings: {
                    total_net_sales: 'Total net sales',
                },
                pdf_url: Laroute.route('franchise.report.item.variant.export', {
                    type: 'PDF',
                }),
                csv_url: Laroute.route('franchise.report.item.variant.export', {
                    type: 'CSV',
                }),
                xls_url: Laroute.route('franchise.report.item.variant.export', {
                    type: 'XLSX',
                }),
            },
        };
    },
    computed: {
        api() {
            return Laroute.route('franchise.report.item.variant.index');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/variant-sales-report.vue